"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEMBERS_STATUS = void 0;
var MEMBERS_STATUS = exports.MEMBERS_STATUS = {
  DELETED: -1,
  PENDING: 0,
  ACCEPTED: 1,
  DENIED: 2
};